import React, {useState, useEffect} from 'react'
import {Modal, Button} from 'react-bootstrap'
import close_icon from '../../assets/images/icons/close-icon.png'
import tick_icon from '../../assets/images/icons/tick-icon.png'
import {useSelector} from 'react-redux'
import { normalizeInput } from '../../utility/utils'



import ModelInput from '../inputText/modelInput';
import SubmitButton from '../loadingButton/modelSubmitButton';
import CancelButton from '../loadingButton/modelCancelButton';
import NotificationMessage from '../../components/notificationMessage';

function RegistrationModel(props) {


  const apiResponse = useSelector(state=>{
    const {registrationStatus} = state
    const {status} = registrationStatus
    return{
      status
    }

  })


  const [signinStatus,
    setSigninStatus] = useState('')

  useEffect(()=>{
    if(apiResponse.status){
      setSigninStatus('Something went wrong, Please contact our team')
    }
  },[apiResponse.status])

    const handleCloseNotificationMessage = ()=>{
      setSigninStatus('')
    }


    const handlePhoneNumber = (text)=>{
      let test = text.target.value
  
      props.setIndividualInputs({
        ...props.individualInputs,
        telephoneNumber:normalizeInput(test, props.individualInputs?.telephoneNumber)
    });
    }

    return (
      <> 
        <Modal 
          show={props.show} 
          onHide={props.hide}
          centered
          size="lg">
          {props.changeView ?<div className="model-body">
            <div className="d-flex model-title">
              <span>{props.registerType? 'Firm Quick Registration' : 'Quick Registration' }</span>
              <div className="d-flex close-ctn" onClick={props.hide}>
                  <span>close</span>
                  <img src={close_icon}/>
              </div>
            </div>
            {signinStatus !== '' && <NotificationMessage 
              signinStatus={signinStatus}
              handleCloseNotificationMessage={handleCloseNotificationMessage}
              style={{
                backgroundColor:'#f2f3f8', 
                display: 'flex', 
                margin: 'auto',
                marginTop: 10
              }}/>}
            <div className="input-fields-ctn mt-4">
                  <ModelInput
                    title="First name"
                    error={props.individualError.firstName}
                    handleChange={(text)=>{props.setIndividualInputs({
                      ...props.individualInputs,
                      firstName:text.target.value
                  });
                  props.setIndividualError({
                      ...props.individualError,
                      firstName:false,
                      firstNameHelperText: ''
                  })
              }}
                    value={props.registrationName}
                    type="text"
                    helperText={props.individualError?.firstNameHelperText}

                    />
                  <ModelInput
                    title="Last name"
                    error={props.individualError.lastName}
                    handleChange={(text)=>{props.setIndividualInputs({
                      ...props.individualInputs,
                      lastName:text.target.value
                  });
                  props.setIndividualError({
                      ...props.individualError,
                      lastName:false,
                      lastNameHelperText: '',
                  })
              }}
                    value={props.registrationName}
                    type="text"
                    helperText={props.individualError?.lastNameHelperText}
                  />
                  <ModelInput
                    title="Phone number"
                    error={props.individualError.telephoneNumber}
                    handleChange={(text)=>{
                      handlePhoneNumber(text)
                  props.setIndividualError({
                      ...props.individualError,
                      telephoneNumber:false,
                      phoneNumberHelperText: '',
                  })
              }}
                    value={props.individualInputs?.telephoneNumber}
                    type="tel"
                    helperText={props.individualError?.phoneNumberHelperText}

                    />
                  <ModelInput
                    title="Email"
                    error={props.individualError.email}
                    handleChange={(text)=>{props.setIndividualInputs({
                      ...props.individualInputs,
                      email:text.target.value
                  });
                  props.setIndividualError({
                      ...props.individualError,
                      email:false,
                      emailHelperText: ''
                  })
              }}
                    value={props.email}
                    type="email"
                    helperText={props.individualError.emailHelperText}
                    />
                  <ModelInput
                    title="Password"
                    handleChange={(text)=>{props.setIndividualInputs({
                      ...props.individualInputs,
                      password:text.target.value
                  });
                  props.setIndividualError({
                      ...props.individualError,
                      password:false,
                      confirmPassword: false,
                      passwordHelperText: ''
                  })
              }}
                    value={props.password}
                    type="password"
                    error={props.individualError.password}
                    helperText={props.individualError?.passwordHelperText}

                    />
                  <ModelInput
                    title="Confirm password"
                    handleChange={(text)=>{props.setIndividualInputs({
                      ...props.individualInputs,
                      confirmPassword:text.target.value
                  });
                  props.setIndividualError({
                      ...props.individualError,
                      password:false,
                      confirmPassword: false,
                      confirmPasswordHelperText: ''
                  })
              }}
                    value={props.password}
                    type="password"
                    error={props.individualError.confirmPassword}
                    helperText={props.individualError?.confirmPasswordHelperText}
                    />
            </div>
            <div className="model-footer-buttons">
              <CancelButton
                title="CANCEL"
                submit={props.hide}/>
              <SubmitButton
                title="SUBMIT"
                submit={props.handleIndividualRegistration}
                disabled={props.disabled}/>
            </div>
          </div> : 
          <>
          {props.regResponse?.code === 200  ? 
            <div className="model-body">
                <div className="d-flex model-title" style={{padding: 20}}></div>
                <div className="success-model-body-content">
                  <img src={tick_icon}/>
                  <span className="thank-you-text">Thank You</span>
                  {/* <span className="thank-you-description">{props.regResponse.description}</span> */}
                  <span className="thank-you-description">A confirmation email has been sent to the email below. Read it and act as requested in it to confirm it</span>
                  <div className="success-email-ctn">
                    <span>{props.email}</span>
                  </div>
                  {/* <span className="thank-you-description">click the link sent to your email to activate your account</span> */}
                  <Button
                    onClick={()=>props.hide()} 
                    className="model-accept-button"
                    variant="light"
                    style={{
                      border: '2px solid #979797',
                      marginTop: 40
                    }}>
                      <span>
                          CLOSE
                      </span>
                  </Button>
                </div>
            </div> : 
            <div className="model-body">
              <div className="d-flex model-title" style={{padding: 20}}></div>
              <div className="success-model-body-content">
                <img src={tick_icon}/>
                <span className="thank-you-description">{props.regResponse.description}</span>
              </div>
            </div>}
          </>
       
          }
        </Modal>
      </>
    );
  }
  
export default RegistrationModel